export default "__VITE_ASSET__c3C4X3bZ__"